import { initializeIcons } from '@fluentui/font-icons-mdl2';
import { LazyImport, LazyModule } from 'owa-bundling';
import { loadItemsViewStrings } from 'owa-items-view-strings';

const lazyModule = new LazyModule(async () => {
    // We need to load the items-view strings before we invoke any of their components or functions
    await loadItemsViewStrings();
    const lazyModule = await import(/* webpackChunkName: "SharingDialog"*/ './lazyIndex');

    // We do not need to wait on the icon initialization, but we should still do it for a smoother experience.
    initializeIcons();
    return lazyModule;
});

// Delay loaded imports
export const lazyOpenSharingDialog = new LazyImport(lazyModule, m => m.sharingDialog);
export { lazyModule as preloadSharingDialogModule };
export type { SharingDialogResponse } from './types/SharingDialogResponse';
